export const BOOKING_DAYS_AHEAD = 90;

export type BookingDateWindow = { min: string; max: string };

export function isIsoDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}

export function calendarLabelToIso(label: string): string | null {
  const match = label.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!match) return null;
  const iso = `${match[3]}-${match[2]}-${match[1]}`;
  return isIsoDate(iso) ? iso : null;
}

export function isoToCalendarLabel(iso: string): string {
  if (!isIsoDate(iso)) return "";
  const [year, month, day] = iso.split("-");
  return `${day}.${month}.${year}`;
}

export function getBookingDateWindow(now = new Date()): BookingDateWindow {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Jerusalem", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const fields = Object.fromEntries(parts.map(part => [part.type, part.value]));
  const min = `${fields.year}-${fields.month}-${fields.day}`;
  // Calendar-day arithmetic at UTC noon avoids daylight-saving and device-zone shifts.
  const last = new Date(`${min}T12:00:00Z`);
  last.setUTCDate(last.getUTCDate() + BOOKING_DAYS_AHEAD);
  return { min, max: last.toISOString().slice(0, 10) };
}

export function isDateInWindow(value: string, range: BookingDateWindow): boolean {
  return isIsoDate(value) && value >= range.min && value <= range.max;
}
